<div class="loader-container">
  <div class="loader">
    <div class="loader-circle" id="a-circle"></div>
    <div class="loader-circle" id="b-circle"></div>
    <div class="loader-circle" id="c-circle"></div>
  </div>
  <div class="loader-caption">Please wait...</div>
</div>
